module.exports = __webpack_public_path__ + "img/1570985345.a361874f.jpg";